export enum MenuItems {
  // For teachers
  Lessons, // Занятия
  Pupils, // Ученики
  Results, // Результаты
  Professions, // Профессии
}
